import(/* webpackMode: "eager", webpackExports: ["UserAuthForm"] */ "/home/runner/_work/platform/platform/packages/dashboard/src/components/forms/user-auth-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnboardingFooter"] */ "/home/runner/_work/platform/platform/packages/dashboard/src/components/ui/onboarding/footer.tsx");
